import { differenceInDays } from 'date-fns';

import { Baseplan } from 'components/types';

export const getWeekCycles = (baseplan: Baseplan, startDate: string) => {
  const days = differenceInDays(
    new Date(startDate),
    new Date(baseplan.validFrom)
  );
  const weeks = Math.floor(days / 7);
  const cycles = Math.floor(weeks / baseplan.weekCount);
  const cyclesLeftover = weeks / baseplan.weekCount - cycles;
  const weeksInCycle = Math.floor(cyclesLeftover * baseplan.weekCount);

  return weeksInCycle + 1;
};
